var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileInitials({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#383838"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Signature applied"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 393,
    height: 852,
    transform: "translate(-148 -705)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Fields options"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 1171277495"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -15.5,
    y: -15.5,
    width: 92,
    height: 47,
    rx: 11.5,
    stroke: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "fi_3188004"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -8,
    y: -8,
    width: 32,
    height: 32,
    rx: 8,
    fill: "#E9E8ED"
  }), /*#__PURE__*/React.createElement("g", {
    id: "fi_16351288"
  }, /*#__PURE__*/React.createElement("g", {
    id: "MI"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9087 3.06456V12H9.76203V5.33716L6.86387 12H6.05743L3.14666 5.32425V12H2V3.06456H3.23487L6.46065 10.4505L9.68643 3.06456H10.9087Z",
    fill: "#1E1341"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 3V12H12.8533V3H14Z",
    fill: "#1E1341"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileInitials);
export default __webpack_public_path__ + "static/media/MobileInitials.d78b603e2ddf45270855000ddf6057b6.svg";
export { ForwardRef as ReactComponent };